const MANAGER_PROFILES = new Set(["departmentmanager", "generalmanager"]);

export const isManagerProfile = (profile: string | undefined | null): boolean =>
    !!profile && MANAGER_PROFILES.has(profile);
